// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';

// Section for import custom components --------------------------------------------------------------------------------
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import Error404 from '@components/Error/404';

import Breadcrumbs from '@components/common/Breadcrumbs';
import App from '../app';

const targetID = 'app-content-404-mansions';

// Section for render component ----------------------------------------------------------------------------------------

// Render component if the targetID element exists in the DOM.
if (document.getElementById(targetID)) {
  const container = document.getElementById(targetID)!;
  const root = createRoot(container);

  const breadcrumbs = container.dataset.breadcrumbs ? JSON.parse(container.dataset.breadcrumbs) : [];

  root.render(
    <App>
      <Header />
      <Error404 />
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Footer />
    </App>,
  );
}
